import { useQuery } from '@tanstack/react-query';
import api from '~/api';
import { useStoreId } from '~/providers/StoreUserProvider';

function useQueryKey() {
  const storeId = useStoreId();
  return ['factValues', storeId] as const;
}

export function useFactValues() {
  const queryKey = useQueryKey();
  return useQuery({
    queryKey,
    queryFn: ({ queryKey: [, storeId] }) => api.store(storeId).factValues.get(),
  });
}

export function useFactValueProductTags() {
  const { data: factValuesData } = useFactValues();
  const productTags = factValuesData?.arbitrary['product/tags'] ?? [];

  return productTags;
}
